// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* React Virtualized Table */\n.ReactVirtualized__Table__headerColumn, .ReactVirtualized__Table__rowColumn,\n.ReactVirtualized__Table__headerColumn:first-of-type, .ReactVirtualized__Table__rowColumn:first-of-type {\n  margin: 0;\n}", ""]);
// Exports
module.exports = exports;
